export default __webpack_public_path__ + "static/media/ic_location_on_48px.098bf978.svg";